module.exports = __webpack_public_path__ + "img/title3.3b27f86d.png";